import type { ScorecardsResult } from '@core/interview-results-types';
import { createSingleEntityStore } from '@core/ngrx-legacy';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<ScorecardsResult[]>()(
  'InterviewResultsScorecards',
  {
    customActions: adapter => ({
      fetch: (state, payload: { candidateId: number; offerId?: number }) =>
        adapter.markAsPending(state),
    }),
  },
);

export {
  actions as InterviewResultsScorecardsActions,
  selectors as InterviewResultsScorecardsSelectors,
  reducer as InterviewResultsScorecardsReducer,
  namespace as InterviewResultsScorecardsNamespace,
};
